<template>
  <div class="flex flex-row w-full">
    <div class="flex flex-row">
      <label class="w-20 flex-none text-xs text-white">Speed</label>
      <numberer class="w-32" v-model='speed' :step='0.5' />
    </div>
</div>

</template>
<script>
import tweens from '@/edit/tree/tweens.js';
import Numberer from '@ui/atoms/Numberer.vue';
import { types, createComponent } from '@edit/tree/componentsdb.js';
import Treeutil from '@edit/tree/treeutil.js';
import { toPairs, groupBy } from 'lodash';
export default {
  props:{
    component:{
      type: Object,
      required: true
    },
    transform: {
      type: Object,
      required: true
    },
    partutil: {
      type: Object,
      required: true
    },
    transformsAndSource:{
      type: Object,
      required:true
    }
  },
  mounted() {
    this.$ana.track({
      eventCategory:'ui',
      eventAction:'showQuickAnimate'
    });
  },
  data() {
    
    const availableQuickmoves = [
      {name:'Left'},
      {name:'Right'},
      {name:'Up'},
      {name:'Down'},
      ]
    const groupedQuickMoves = toPairs(groupBy(availableQuickmoves, 'group')).map( ([group,quickMoves]) => {
      return {
        group,
        quickMoves
      }
    });
    console.log('GROUPED IT', groupedQuickMoves);

    const treeutil = new Treeutil(this.transformsAndSource.from);

    return {
      quickmoves: [],
      availableQuickmoves,
      groupedQuickMoves,
      treeutil,
      tweens
    }
  },
  methods: {
    isSelected(quickMove) {
      return false;
    },
    quickmoveClasses(quickMove) {
      const classes = ["flex-none m-1 p-1 text-xs leading-snug tracking-tight rounded"];
      if (this.isSelected(quickMove)) {
        classes.push('bg-green-500 text-white border-2 border-white');
      } else {
        classes.push('bg-gray-200 border border-gray-400 text-gray-700');
      }
      return classes;
    },
    toggleQuickmove(quickMove) {
      console.log('toggle!!');
      if (!this.isSelected(quickMove)) {
      } else {
      }
    }
  },
  components:{
  },
  computed:{
    speed:{
      get() {
        const dx = this.component.dx;
        const dy = this.component.dy;
        return Math.sqrt(dx*dx + dy*dy);
      },
      set(nv) {
        console.log('set distance', nv);
        const dx = this.component.dx;
        const dy = this.component.dy;
        const dist = Math.max(0.1, Math.sqrt(dx*dx + dy*dy));
        const normdx = dx/dist;
        const normdy = dy/dist;
        this.component.dx = normdx * nv;
        this.component.dy = normdy * nv;
        console.log('set to', this.component.dx, this.component.dy);
      }
    }
  }
}
</script>
<style>
.quick-move-groups {
  @apply flex flex-col;
}
</style>
